(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/constants.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/constants.js');
'use strict';

svs.termsIntegrity.constants.route = {
  TIR_HOME: '/',
  TIR_INTEGRITY: '/personuppgifter',
  TIR_TERMS: '/villkor',
  TIR_RULES: '/spelregler'
};
svs.termsIntegrity.constants.general = {
  FETCH_SIZE: 100
};

 })(window);